import { render, staticRenderFns } from "./ListaDeFacturasExterno.vue?vue&type=template&id=2564cb44&scoped=true"
import script from "./ListaDeFacturasExterno.vue?vue&type=script&lang=js"
export * from "./ListaDeFacturasExterno.vue?vue&type=script&lang=js"
import style0 from "./ListaDeFacturasExterno.vue?vue&type=style&index=0&id=2564cb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564cb44",
  null
  
)

export default component.exports